export const permissionRules = {
    Admin: ['Admin', 'Superadmin'],
    InventoryAdmin: ['Inventory Admin', 'Admin', 'Superadmin'],
    Employee: ['Employee', 'New Employee'],
    All: ['Employee', 'New Employee', 'Inventory Admin', 'Admin', 'Superadmin'],
};
